import { createRouter, createWebHistory } from "vue-router";

import AgentLogin from "@/pages/AgentLogin.vue";
import AgentInbox from "@/pages/AgentInbox.vue";

import ManagerDashboard from "@/pages/ManagerDashboard.vue";
import MDashboard from "@/pages/Manager/MDashboard.vue";
import BroadcastCampaigns from "@/pages/Manager/BroadcastCampaigns.vue";
import TemplateMaster from "@/pages/Manager/TemplateMaster.vue";

import ManagerFlows from "@/pages/ManagerFlows.vue";
import omini from "@/pages/OmnichannelLayout.vue";
import Bots from "@/pages/BotsList.vue";
import WhatsAppConfigPage from "@/pages/WhatsAppConfigPage.vue";

import AdminDashboard from "@/pages/admin/AdminDashboard.vue";
import AdminTenants from "@/pages/admin/AdminTenants.vue";
import AdminUsers from "@/pages/admin/AdminUsers.vue";
import AdminUsersNew from "@/pages/admin/AdminUsersNew.vue";
import AdminFlows from "@/pages/admin/AdminFlows.vue";
import AdminProfile from "@/pages/admin/AdminProfile.vue";

const routes = [
  // public
  {
    path: "/",
    name: "login",
    component: AgentLogin,
    meta: { public: true },
  },

  // agent
  {
    path: "/inbox",
    name: "agent-inbox",
    component: AgentInbox,
    meta: { roles: ["agent", "manager", "admin"] },
  },

  // manager
  {
    path: "/manager",
    name: "manager-dashboard",
    component: ManagerDashboard,
    meta: { roles: ["manager", "admin"] },
  },
  {
    path: "/manager/dashboard",
    name: "MDashboard",
    component: MDashboard,
    meta: { roles: ["manager", "admin"] },
  },
  {
    path: "/omini",
    name: "omini",
    component: omini,
    // meta: { roles: ["manager", "admin"] },
  },
  {
    path: "/manager/bots",
    name: "bots",
    component: Bots,
    meta: { roles: ["manager", "admin"] },
  },
  {
    path: "/manager/whatsapp",
    name: "WhatsAppConfigPage",
    component: WhatsAppConfigPage,
    meta: { roles: ["manager", "admin"] },
  },
  {
    path: "/manager/broadcastcampaigns",
    name: "BroadcastCampaigns",
    component: BroadcastCampaigns,
    meta: { roles: ["manager", "admin"] },
  },
  {
  path: "/manager/wa-templates",
  name: "wa-templates",
  component: TemplateMaster,
  meta: { roles: ["manager", "admin"] },
  },
  {
    path: "/manager/flows",
    name: "manager-flows",
    component: ManagerFlows,
    meta: { roles: ["manager", "admin"] },
  },
  {
    path: "/manager/flows/:id/designer",
    name: "manager-flow-designer",
    component: () => import("@/pages/ManagerFlowDesigner.vue"),
    meta: { roles: ["manager", "admin"] },
  },

  // admin
  {
    path: "/admin/dashboard",
    name: "admin-dashboard",
    component: AdminDashboard,
    meta: { roles: ["admin"] },
  },
  {
    path: "/admin/tenants",
    name: "admin-tenants",
    component: AdminTenants,
    meta: { roles: ["admin"] },
  },
  {
    path: "/admin/users",
    name: "admin-users",
    component: AdminUsers,
    meta: { roles: ["admin"] },
  },
  {
    path: "/admin/users/new",
    name: "admin-user-new",
    component: AdminUsersNew,
    meta: { roles: ["admin"] },
  },
  {
    path: "/admin/flows",
    name: "admin-flows",
    component: AdminFlows,
    meta: { roles: ["admin"] },
  },
  {
    path: "/admin/profile",
    name: "admin-profile",
    component: AdminProfile,
    meta: { roles: ["admin"] },
  },

  // fallback
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const userRaw = localStorage.getItem("user");

  let user = null;
  try {
    user = userRaw ? JSON.parse(userRaw) : null;
  } catch (e) {
    user = null;
  }

  // public route
  if (to.meta.public) {
    if (token && user?.role) {
      if (user.role === "admin") return next("/admin/dashboard");
      if (user.role === "manager") return next("/manager");
      return next("/inbox");
    }
    return next();
  }

  // protected route
  if (!token || !user?.role) {
    return next("/");
  }

  const allowedRoles = to.meta.roles || [];
  if (allowedRoles.length && !allowedRoles.includes(user.role)) {
    if (user.role === "admin") return next("/admin/dashboard");
    if (user.role === "manager") return next("/manager");
    return next("/inbox");
  }

  next();
});

export default router;